import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.21.6_@parcel+watcher@2.5.6_@types+node@24.12.4_@vue+compiler-sfc@3.5.34_cac@6.7._5fb85f7cd389bdca4523d1116a45d9d0/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}